import slugify from "slugify";
import type { LanguageCode } from "./language";

const slugifyConfig = {
  replacement: "-",
  remove: undefined,
  lower: true,
  strict: true,
  trim: true,
};

export const createSlug = (title: string, language: LanguageCode) => {
  return slugify(title || "post", { ...slugifyConfig, locale: language });
};
